@if (cache?.asset; as asset) {
  <div class="row">
    <div class="col-12">
      <trade-asset-links [asset]="cache.asset" />
      @if (tradeFacade.isCombinedOrderVerified$ | async) {
        @if (tradeFacade.isFractionalOrderOnly$ | async) {
          <ng-container *ngTemplateOutlet="fractionalExante; context: { asset }" />
        } @else {
          <ng-container *ngTemplateOutlet="marketOrderExante; context: { asset }" />
          @if (tradeFacade.combinedFractionalOrder$ | async) {
            <ng-container *ngTemplateOutlet="fractionalExante; context: { asset }" />
          }
        }
      } @else {
        <ng-container *ngTemplateOutlet="marketOrderExante; context: { asset }" />
      }
    </div>
  </div>
}

<ng-template #marketOrderExante let-asset="asset">
  <div class="font-size-smaller2">
    <trade-exante [inputData]="asset" />
  </div>
</ng-template>

<ng-template #fractionalExante let-asset="asset">
  <div class="font-size-smaller2">
    <trade-exante [inputData]="asset" [isFraction]="true" />
  </div>
</ng-template>
